import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-04193e38")

_pushScopeId("data-v-04193e38")
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  height: "66",
  alt: "マンガフィールド"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "separator" }, null, -1)
const _hoisted_5 = { class: "menu" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "icon-text" }, "Topへ戻る", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "icon-text" }, "ヘルプ", -1)
const _hoisted_8 = {
  key: 0,
  class: "auth"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "icon-text" }, "マイページ", -1)
const _hoisted_10 = { class: "center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "保存したマンガを見る", -1)
const _hoisted_12 = { class: "center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "パスワードの変更", -1)
const _hoisted_14 = { class: "center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "ログアウト", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_fa = _resolveComponent("fa")
  const _component_HLine = _resolveComponent("HLine")
  const _component_ChangePassword = _resolveComponent("ChangePassword")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h1", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/top" }, {
          default: _withId(() => [
            (!_ctx.isHideTitle)
              ? (_openBlock(), _createBlock("img", _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        (!_ctx.isHideTitle)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/top"
            }, {
              default: _withId(() => [
                _createVNode(_component_fa, { icon: ['fas', 'arrow-left'] }),
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode("a", {
          href: _ctx.helpPdf,
          target: "_blank",
          rel: "noopener noreferrer"
        }, [
          _createVNode(_component_fa, { icon: ['far', 'question-circle'] }),
          _hoisted_7
        ], 8, ["href"])
      ]),
      (_ctx.isLoggedin)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("a", {
              href: "#",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["prevent"]))
            }, [
              _createVNode(_component_fa, { icon: ['far', 'user'] }),
              _hoisted_9
            ]),
            _withDirectives(_createVNode("div", {
              onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
              ref: "userInfo",
              tabindex: "1",
              class: "dialog"
            }, [
              _createVNode("p", null, "ユーザーID: " + _toDisplayString(_ctx.mail), 1),
              _createVNode("div", _hoisted_10, [
                _createVNode("button", {
                  class: "primary-button width",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toSaveDataList && _ctx.toSaveDataList(...args)))
                }, [
                  _hoisted_11
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("button", {
                  class: "primary-button width",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openChangePass && _ctx.openChangePass(...args)))
                }, [
                  _hoisted_13
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("button", {
                  class: "primary-button width",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                }, [
                  _hoisted_15
                ])
              ])
            ], 544), [
              [_vShow, _ctx.isOpened]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isHideTitle)
      ? (_openBlock(), _createBlock(_component_HLine, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ChangePassword, {
      isShowModal: _ctx.isShowModal,
      "onUpdate:isShowModal": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowModal = $event))
    }, null, 8, ["isShowModal"])
  ], 64))
})